module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.42750cb8.png";